import React, { useContext } from 'react';
import classNames from 'classnames';
import { CloseOutlined as MenuIconOpen } from 'jl-design-system/components/icons/CloseOutlined';
import { MenuOutlined as MenuIconClosed } from 'jl-design-system/components/icons/MenuOutlined';

import { AccountLinks } from '../account-links/AccountLinks';
import { Basket } from '../basket/Basket';
import { StoreFinderIcon } from '../store-finder-icon/StoreFinderIcon';
import { EnvVarsFeaturesContext } from '../../scaffold/EnvVarsFeaturesContext';

import styles from './user-tools.scss';

export const UserTools = ({
  isMenuOpen,
  onMenuButtonClick,
  isTypeaheadOpen,
}) => {
  const { features } = useContext(EnvVarsFeaturesContext);
  const shouldHideBasket = features.mvoMode || features.hideBasketIcon;

  const menuButtonChildren = (
    <>
      <span className={styles.visuallyHidden}>
        {isMenuOpen ? 'Close' : 'Menu'}
      </span>

      {isMenuOpen ? (
        <MenuIconOpen
          className={styles.icon}
          dataTestId="nav-menu-close-icon"
          size="medium"
          title="Close Menu"
        />
      ) : (
        <MenuIconClosed
          className={styles.icon}
          dataTestId="nav-menu-icon"
          size="medium"
          title="Open Menu"
        />
      )}

      <span className={styles.navListItemLabel} data-testid="nav-menu-label">
        {isMenuOpen ? 'Close' : 'Menu'}
      </span>
    </>
  );

  return (
    <nav
      data-testid="user-tools-nav"
      className={classNames(styles.nav, {
        [styles.nav__active]: isTypeaheadOpen,
      })}
    >
      <ul className={classNames(styles.navList)}>
        <li className={classNames(styles.navListItem, styles.storeFinder)}>
          <StoreFinderIcon />
        </li>
        <li className={styles.navListItem}>
          <AccountLinks />
        </li>
        {!shouldHideBasket && (
          <li className={styles.navListItem}>
            <Basket>
              <span
                className={styles.navListItemLabel}
                data-testid="basket-icon-label"
              >
                Basket
              </span>
            </Basket>
          </li>
        )}
        <li
          className={classNames(styles.navListItem, styles.menu)}
          data-testid="menu-icon"
        >
          <a
            href="/menu"
            className={styles.navListItemLink}
            data-testid="nav-link--menu"
            onClick={onMenuButtonClick}
            role="button"
            aria-expanded={isMenuOpen}
            aria-controls="main-navigation-menu"
          >
            {menuButtonChildren}
          </a>
        </li>
      </ul>
    </nav>
  );
};
